module.exports = __webpack_public_path__ + "img/photo_2023-04-22_08-14-38.5833367e.jpg";